import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-fontawesome',
  templateUrl: './icon-fontawesome.component.html',
  styleUrls: ['./icon-fontawesome.component.scss']
})
export class IconFontawesomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
